define('lib/view/BaseTemplateHelper',['require','handlebars','Config','lib/Utils'],function (require) {

    var Handlebars = require('handlebars');
    var Config = require('Config');
    var Utils = require('lib/Utils');

    // fix textareas rendering multiline texts with extra indents
    var oldTemplateCacheGet = Marionette.TemplateCache.get;
    Marionette.TemplateCache.get = function(template, options) {
        var effectiveOptions = _.extend({
            preventIndent: true
        }, options);
        return oldTemplateCacheGet.call(this, template, effectiveOptions);
    };

    // ----- translations -----

    var untranslated = [];
    Handlebars.registerHelper('dump_untranslated', function() {
        var res = '';
        var res2 = [];
        _.each(untranslated, function (str) {
            res += 'msgid "' + str + '"' + "\n" + 'msgstr "' + str + '"' + "\n\n";
            res2.push('"' + str + '"');
        });

        console.log(res);
        console.log(res2.join(', '));
    });

	/**
	 * Translate helper
	 *
	 * @param String text
	 * @return String
	 */
	Handlebars.registerHelper('_t', function(text, options) {
        if (!Locale.has(text) && untranslated.indexOf(text) === -1) {
            untranslated.push(text);
        }

        var result = Locale.getNonEscape(text);
        if (!result) {
            result = '';
        }

	    if (options.hash && options.hash._data) {
            _.each(options.hash._data, function (value, key) {
                if (_.isString(value) || _.isNumber(value)) {
                    result = result.replace('%' + key + '%', value);
                }
            });
        }
        _.each(options.hash, function (value, key) {
            if (_.isString(value) || _.isNumber(value)) {
                result = result.replace('%' + key + '%', value);
            }
        });
		return result;
	});

    Handlebars.registerHelper('makeEmbedVideoUrl', function(text, options) {
        if(!text){
            return false;
        }
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = text.match(regExp);
        var id = (match&&match[7].length==11)? match[7] : false;
        if(!id){
            return false;
        }
        return 'https://www.youtube.com/embed/' + id;
    });

    // ----- conditionals -----

    /**
	 * Checks if v1 is 'rule' to v2
     * use it like this: {{#ifCond v1 rule v2}}your code {{/ifCond}}
	 *
	 * @param mixed v1
     * @param String rule
	 * @param mixed v2
	 * @param Object options
	 */
    Handlebars.registerHelper('ifCond', function(v1, rule, v2, options) {
        return cond.apply(this, arguments);
    });

    Handlebars.registerHelper('isCond', function(v1, rule, v2) {
        return _cond.apply(this, arguments);
    });

    Handlebars.registerHelper('ifCondLength', function(v1, rule, v2, options) {
        if(!_.isObject(v1) && !_.isArray(v1)){
            return cond.apply(this, [0, rule, v2, options]);
        }
        return cond.apply(this, [v1.length, rule, v2, options] );
    });


    /**
     * Checks if v1 is 'rule' to v2
     * use it like this: {{#if cond(v1 rule v2)}}your code {{/if}}
     *
     * @param mixed v1
     * @param String rule
     * @param mixed v2
     * @param Object options
     */
    Handlebars.registerHelper('cond', function(v1, rule, v2, options) {
        return _cond.apply(this, arguments);
    });

    Handlebars.registerHelper('iif', function(condition, positive, negative) {
        return condition ? positive : negative;
    });

    Handlebars.registerHelper('configParam', function(param, rule, val, options) {
        var args = [
            Config.getInstance().getOption(param),
            rule, val, options
        ];

        return _cond.apply(this, args);
    });


    Handlebars.registerHelper('eq', function (a, b) {
        return a === b;
    });


    /**
     * Checks if config param comply with rule and val
     *
     * @param String param
     * @param String rule
     * @param mixed val
     */
    Handlebars.registerHelper('ifConfigParam', function(param, rule, val, options) {
        var args = [
            Config.getInstance().getOption(param),
            rule, val, options
        ];

        return cond.apply(this, args);
    });

    Handlebars.registerHelper('ifIndex', function(arr, firstItem, condition, secondItem, options) {
        var firstIndex = _.indexOf(arr, firstItem);
        var secondIndex = _.indexOf(arr, secondItem);

        return cond(firstIndex, condition, secondIndex, options);
    });

    Handlebars.registerHelper('ifIn', function(elem, list, options) {
        if(!list){
            return false;
        }

        if(_.isObject(list) && !_.isArray(list)){
            list = _.keys(list);
        }

        if (!_.isFunction(options.fn)) { // to make possible to call it iside of other functions
            return list.indexOf(elem) > -1;
        }

        if(list.indexOf(elem) > -1) {
            return options.fn(this);
        }
        return options.inverse(this);
    });

    Handlebars.registerHelper('ifNotEmpty', function(value, options) {
        if (value || (options.hash && options.hash.force)) {
            return options.fn(this);
        }
        return options.inverse(this);
    });

    Handlebars.registerHelper('ifEmpty', function(value, options) {
        if (value === "" || value === 0   || value === "0" || value === null  || value === false  ||  (Array.isArray(value) && value.length === 0)) {
            return options.fn(this);
        }
        return options.inverse(this);
    });

    Handlebars.registerHelper('ifEven', function(conditional, options) {
        if ((conditional % 2) === 0) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    Handlebars.registerHelper('ifShowPriceWithTax', function(options) {
        var showTax = !Config.getInstance().getOption('hide_sale_tax');
        if (options.hash && options.hash.show_tax) {
            showTax = options.hash.show_tax;
        }
        if (showTax && Config.getInstance().getOption('sale_tax') > 0) {
            return options.fn(this);
        }
        return options.inverse(this);
    });

    Handlebars.registerHelper('ifHasTax', function(options) {
        if (Config.getInstance().getOption('sale_tax') > 0) {
            return options.fn(this);
        }
        return options.inverse(this);
    });

    Handlebars.registerHelper('ifShowProviderDetails', function (providerId, options) {
		if (!providerId) {
			return options.inverse(this);
		}
        if (!Config.getInstance().getOption('any_unit_hide_other_units')) {
            return options.fn(this);
        }
        //NB use this case instead of previous if you want to hide Any provider always
        // if (providerId !== 'any' && !Config.getInstance().getOption('any_unit_hide_other_units')) {
        //     return options.fn(this);
        // }
        return options.inverse(this);
    });

    /**
     * Analog of smarty's assign variable
     */

    Handlebars.registerHelper('setVariable', function(varName, varValue, options) {
        varName = String(varName).split('.');
        if(varName.length == 1) {
            options.data.root[varName[0]] = varValue;
        } else {
            var currObj = options.data.root
            for(var i = 0; i<varName.length; i++){
                if(_.isEmpty(options.data.root[varName[i]]) || !_.isObject(options.data.root[varName[i]])){
                    currObj[varName[i]] = {};
                }
                if(varName.length-1 == i){
                    currObj[varName[i]] = varValue;
                }
                currObj = currObj[varName[i]];
            }
        }
    });
    /**
     * @param v1
     * @param rule
     * @param v2
     * @param options
     * @returns {*}
     */
    function cond(v1, rule, v2, options) {
        if (_cond(v1, rule, v2)) {
            return options.fn(this);
        }
        return options.inverse(this);
    }

    /**
     * @param v1
     * @param rule
     * @param v2
     * @returns {boolean}
     * @private
     */
    function _cond(v1, rule, v2) {
        switch (rule) {
            case '>':
                if (v1 > v2) {
                    return true;
                }
                break;
            case '<':
                if (v1 < v2) {
                    return true;
                }
                break;
            case '>=':
                if (v1 >= v2) {
                    return true;
                }
                break;
            case '<=':
                if (v1 <= v2) {
                    return true;
                }
                break;
            case '==':
                if (v1 == v2) {
                    return true;
                }
                break;
            case '!=':
                if (v1 != v2) {
                    return true;
                }
                break;
            case '===':
                if (v1 === v2) {
                    return true;
                }
                break;
            case '!==':
                if (v1 !== v2) {
                    return true;
                }
                break;
            case 'in':
                if (v2 && v2.indexOf(v1) > -1) {
                    return true;
                }
                break;
        }
        return false;
    }

    /**
     * Return not val
     *
     * @param mixed val
     * @param Object options
     */
    Handlebars.registerHelper('not', function(val, options) {
        return !val;
    });

    Handlebars.registerHelper('or', function() {
        var args = Array.prototype.slice.call(arguments);
        var options = args.pop();

        var result = false;
        _.each(args, function (arg) {
            result = result || arg;
        });

        return result;
    });

    Handlebars.registerHelper('and', function() {
        var args = Array.prototype.slice.call(arguments);
        var options = args.pop();

        var result = true;
        _.each(args, function (arg) {
            result = result && arg;
        });

        return result;
    });

    // ----- config -----
    /**
     * Returns config parameter
     *
     * @param String param
     * @param String rule
     * @param mixed val
     */
    Handlebars.registerHelper('getConfigParam', function(param, options) {
        return Config.getInstance().getOption(param);
    });

    Handlebars.registerHelper('timeframe', function () {
        return ~~Config.getInstance().getTimeFrame();
    });

    Handlebars.registerHelper('timeformat', function () {
        return Config.getInstance().getTimeFormat();
    });

    // ----- url ------
    Handlebars.registerHelper('currentUrl', function(options) {
        return location.href;
    });

    Handlebars.registerHelper('urlEncode', function(value, options) {
        return encodeURI(value);
    });

    Handlebars.registerHelper('encodeURIComponent', function(value, options) {
        return encodeURIComponent(value);
    });

    // ----- iterations and data manipulation -----
    Handlebars.registerHelper('array', function() {
        return Array.prototype.slice.call(arguments, 0, -1);
    });

    Handlebars.registerHelper('object', function(options) {
        return options.hash;
    });

    Handlebars.registerHelper('withData', function (options) {
        var data = {};
        var _this = this;
        _.each(options.hash, function (value, key) {
            data[key] = _this[value];
        });

        return options.fn(data);
    });

    Handlebars.registerHelper('_', function(object, key) {
        if (object[key]) {
            return object[key];
        }
    });

    // ----- string and number operations -----
    Handlebars.registerHelper('add', function(val1, val2) {
        return val1 + val2;
    });

    Handlebars.registerHelper('minus', function(val1, val2) {
        return val1 - val2;
    });

    Handlebars.registerHelper('concat', function() {
        var result = '';
        _.each(arguments, function (substr) {
            if (_.isString(substr) || _.isNumber(substr)) {
                result += substr;
            }
        });

        return result;
    });

    Handlebars.registerHelper('join', function(list, glue) {
        //check if list is array
        if (!_.isArray(list) && _.isString(list)) {
            list = [list];
        }
        if(!_.isArray(list) && _.isObject(list)){
            list = _.values(list);
        }
        glue = glue || '';
        return list.join(glue);
    });

    Handlebars.registerHelper('replace', function(str, from, to, options) {
        return str.replace(from, to);
    });

    /**
     *  random number from 'from' to 'to' inclusive
     */
    Handlebars.registerHelper('rand', function(from, to, options) {
        return Math.floor((Math.random() * (to - from + 1)) + from);
    });

    // ----- formatters -----

    Handlebars.registerHelper('formatLimits', function(value) {
        if (value == -1) {
            return Locale.get('infinity');
        }
        return ~~value;
    });

    Handlebars.registerHelper('formatInvoiceLines', function (lines) {
        var result = [];
        _.each(lines, function (line) {
            if (line.package_qty > 0) {
                var packageLine = _.clone(line);

                packageLine.qty = line.package_qty;
                packageLine.price = 0;
                packageLine.amount = 0;
                packageLine.tax_amount = 0;
                packageLine.discount = 0;
                packageLine.discount_amount = 0;
                packageLine.discount_ratio = 0;

                result.push(packageLine);

                if (line.qty > line.package_qty) {
                    line.qty -= line.package_qty;

                    result.push(line);
                }
            } else {
                result.push(line);
            }
        });

        return result;
    });

    /**
     * Formats date period to show it in 15 - 20 March or 10 March - 10 April
     *
     * @param object options
     * @return string
     */
    Handlebars.registerHelper('formatDatePeriod', function(options) {
        if (!options.hash || !options.hash.from || !options.hash.to) {
            throw 'Options "from" and "to" are required';
        }
        var from = options.hash.from;
        if (_.isString(from)) {
            from = Date.parseMysqlDate(from);
        }
        var to = options.hash.to;
        if (_.isString(to)) {
            to = Date.parseMysqlDate(to);
        }

        var format = (options.hash && options.hash.format);
        var fromStr, toStr;


        switch (format) {
            case 'day':
                fromStr = from.getDate();
                toStr = to.getDate();
                break;

            case 'date':
                fromStr = from.getFormattedDate(true);
                toStr = to.getFormattedDate(true);
                break;

            case 'datetime':
                fromStr = from.getFormattedDateTime();
                toStr = to.getFormattedDateTime();
                break;

            case 'month':
                var type = 'long';
                if (options.hash && options.hash.type) {
                    type = options.hash.type;
                }
                fromStr = from.getMonthName(type);
                toStr = to.getMonthName(type);
                break;

            case 'custom':
                fromStr = from.formatDate(options.hash.custom_format, true);
                toStr = to.formatDate(options.hash.custom_format, true);
                break;

            case 'time':
                var fromTime = new Time(from);
                var toTime = new Time(to);
                fromStr = fromTime.getFormattedTime();
                toStr = toTime.getFormattedTime();
                break;

            default:
                fromStr = from.formatDate('j', true);
                if (from.getMonth() !== to.getMonth()) {
                    fromStr = from.formatDate('j F', true);
                }
                toStr = to.formatDate('j F', true);
                break;
        }

        if (_.isFunction(options.fn)) {
            return options.fn({
                'from': fromStr,
                'to': toStr
            });
        }

        return fromStr + ' — ' + toStr;
    });

	/**
	 * Date time format
	 *
	 * @param mixed value
	 * @param String format
     * @param Integer timeDiff - time difference in minutes
	 * @return String
	 */
	Handlebars.registerHelper('formatDateTime', function(value, format, timeDiff, options) {
	    if (value === null) {
            value = new Date();
        }
	    if (_.isUndefined(timeDiff)) {
            timeDiff = 0;
        }
        if (_.isObject(timeDiff)) {
            options = timeDiff;
            timeDiff = 0;
        }

        var val = null;
        if (_.isDate(value)) {
            val = new Date(value);
        } else if (_.isString(value)) {
            val = Date.parseMysqlDate(value);
        }
        val.setTime(val.getTime() + timeDiff * 60 * 1000);

		switch (format) {
            case 'day':
                return val.getDate();
            case 'date':
                return val.getFormattedDate(true);
            case 'datetime':
                return val.getFormattedDateTime(true);
            case 'month':
                var type = 'long';
                if (options.hash && options.hash.type) {
                    type = options.hash.type;
                }
                return val.getMonthName(type);
            case 'custom':
                return val.formatDate(options.hash.format, true);
            case 'time':
                var time = new Time(val);
                return time.getFormattedTime();
            case 'year':
                return val.getFullYear();
        }
	});

    /**
     * Date time format
     *
     * @param mixed value
     * @param String format
     * @param Integer timeDiff - time difference in minutes
     * @return String
     */
    Handlebars.registerHelper('formatTimeStr', function(value, options) {
        var time = new Time(value);
        return time.getFormattedTime();
    });

    /**
     * Shows date diffrenece
     *
     * @param mixed v1
     * @param String rule
     * @param mixed v2
     * @param Object options
     */
    Handlebars.registerHelper('dayDifference', function(datetime, timeDiff, options) {
        if (_.isUndefined(timeDiff)) {
            timeDiff = 0;
        }

        var val = null;
        if (_.isDate(datetime)) {
            val = new Date(datetime);
        } else if (_.isString(datetime)) {
            val = Date.parseMysqlDate(datetime);
        }

        var val2 = new Date(val);
        val2.setTime(val.getTime() + timeDiff * 60 * 1000);

        if (val2.getDate() !== val.getDate()) {
            var diff = timeDiff / 60 / 24;
            if (diff > 0) {
                diff = Math.ceil(diff);
            }
            if (diff < 0) {
                diff = Math.floor(diff);
            }

            var result = {
                'day_diff': (diff > 0 ? '+' : '') + diff + ' ' + Locale.get('day'),
                'date': val2.getFormattedDate()
            };
            return options.fn(result);
        } else {
            return options.inverse(this);
        }
    });

    /**
     * Returns month name by month index
     *
     * @param Integer month
     * @param String type
     * @return String
     */
    Handlebars.registerHelper('formatMonth', function(month, type, options) {
        if (_.isObject(type)) {
            options = type;
            type = null;
        }
        if (!type) {
            type = 'long';
        }
        var res = new Date().getMonthNameByIndex(month, type);

        if (type === 'long') {
            res = Locale.getNonEscape('_' + res + '_');
        }

        return res;
    });

    /**
     * @param {integer} index 1=Monday, 0=7=Sunday
     * @param {string} type long|short|medium
     */
    Handlebars.registerHelper('formatWeekday', function(index, type) {
        if (!type) {
            type = 'long';
        }

        var list;
        switch (type) {
            case 'short':
                list = new Date().weekDayShort;
                break;

            case 'medium':
                list = new Date().weekDayMedium;
                break;

            default:
                list = new Date().weekDaysLong;
                break;
        }

        return Locale.getNonEscape(list[index % 7]);
    });

    Handlebars.registerHelper('formatAddress', function(address, options) {
        if (!options) {
            address = address.hash;
        }

        var order = ['address1', 'address2', 'city', 'country', 'zip'];
        var data = [];
        _.each(order, function (key, field) {
            if (address[key]) {
                data.push(address[key]);
            }
        });

        var result = data.join(', ');
        if (!result.length && address.name) {
            result = address.name;
        }

        return result;
    });

    Handlebars.registerHelper('formatUrl', function(url, options) {
        var result = url;
        if (options.hash.add_scheme) {
            if (result.search('://') === -1) {
                result = 'http://' + result;
            }
        }
        if (options.hash.delete_scheme) {
            result = result.replace('http://', '').replace('https://', '');
        }

        return result;
    });

    Handlebars.registerHelper('formatDiscount', function(discount, options) {
        var res = parseFloat(discount);
        if (options.hash && options.hash.add_percentage) {
            res += ' %';
        }
        return res;
    });
    
    Handlebars.registerHelper('calcVat', function(amount, rate, options) {
        return Math.round(rate * amount * 100) / 10000; 
    });

    /**
     * copied from htdocs/v2/js/userv2/settings/plugins.js
     */
    function getYoutubeId (url) {
        var ID = '';
        url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        if(url[2] !== undefined) {
            ID = url[2].split(/[^0-9a-z_\-]/i);
            ID = ID[0];
        }
        else {
            ID = url;
        }
        return ID;
    }

    function getYoutubeFrameUrl(youtubeId) {
        return "https://www.youtube.com/embed/" + youtubeId;
    }

    Handlebars.registerHelper('videoFrameUrl', function(url, options) {
        return getYoutubeFrameUrl(getYoutubeId(url));
    });

    /**
     * copied from htdocs/v2/js/userv2/settings/plugins.js
     */
    Handlebars.registerHelper('videoFrame', function(url, options) {
        var width = (options && options.width) || '100%';
        var height = (options && options.height) || '400';
        var iframeUrl = getYoutubeFrameUrl(getYoutubeId(url));

        return '<iframe width="' + width + '" height="' + height + '" src="' + iframeUrl + '" frameborder="0" allowfullscreen></iframe>';
    });


    Handlebars.registerHelper('formatPrice', function(price, options) {
        var priceVal = 0;
        if (_.isObject(price)) {
            // new style. simplier to use
            options = price;

            if (options.hash.price !== undefined) {
                var discount = options.hash.discount || 0;
                priceVal = parseFloat(options.hash.price);
                priceVal = priceVal - (priceVal * discount);
                if (options.hash.tax) {
                    if (!Config.getInstance().getOption('price_includes_tax')) {
                        priceVal *= 1 + options.hash.tax.ratio;
                    }
                }
            }
        } else {
            // @deprecated
            // old style
            priceVal = parseFloat(price);
            // include tax to price
            if (Config.getInstance().getOption('sale_tax') > 0 && !Config.getInstance().getOption('hide_sale_tax') && options.hash.include_tax && !options.hash.price_includes_tax) {
                priceVal *= 1 + (Config.getInstance().getOption('sale_tax') / 100);
            }
            // exclude tax from price
            if (Config.getInstance().getOption('sale_tax') > 0 && !options.hash.include_tax && options.hash.price_includes_tax) {
                priceVal /= 1 + (Config.getInstance().getOption('sale_tax') / 100);
            }
        }

        // why do we need it? in this case it will cause issue with currencies like BHD
        /*var decimalsCnt = 2;
        var multiply = Math.pow(10, decimalsCnt);
        priceVal = Math.round(priceVal * multiply) / multiply;*/

        var currency = null;
        switch (options.hash.currency) {
            case 'USD':
                currency = '$';
                break;
            case 'EUR':
                currency = '&euro;';
                break;
            case 'GBP':
                currency = '&pound;';
                break;
        }

        return Utils.formatPrice(priceVal, options.hash.currency, options.fn);
    });

    Handlebars.registerHelper('textlength', function(html, options) {
        return jQuery('<div>' + html + '</div>').text().trim().length;
    });

    Handlebars.registerHelper('substr', function(string, start,  end) {
        return string.substring(start, end);
    });

    Handlebars.registerHelper('cookie', function(name) {
        return $.cookie(name);
    });

    Handlebars.registerHelper('roundToHalf', function(number) {
        return Math.round(number*2)/2;
    });

    Handlebars.registerHelper('pick', function(object, key, defaultValue) {
        return (object && object[key]) || defaultValue; 
    });

    Handlebars.registerHelper('apply', function(object, method, params, defaultValue) {
        return (object && typeof object[method] === 'function') ? object[method].apply(object, params) : defaultValue;
    });

    Handlebars.registerHelper('ifSvg', function(filename, options) {
        if (filename && /\.svg$/.test(filename)) {
            return options.fn(this);
        }
        return options.inverse(this);
    });

    // ----- icons -----
    Handlebars.registerHelper('faIcon', function(name) {
        var cls;
        switch (name) {
            default:
                cls = 'fa fa-' + name;
                break;
        }
        return new Handlebars.SafeString('<i class="' + cls + '" aria-hidden="true"></i>');
    });

    // ----- debug -----
    Handlebars.registerHelper('debug', function(options) {
        console.log('----- debug -----');
        _.each(this, function (value, key) {
            console.log(key, ' = ', value);
        });
    });

});

